import script from "./category.vue?vue&type=script&setup=true&lang=js"
export * from "./category.vue?vue&type=script&setup=true&lang=js"

import "./category.vue?vue&type=style&index=0&id=a7639e2a&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7639e2a"]])

export default __exports__